import { SyntheticEvent, useEffect } from "react"
import {
  Block,
  ButtonIcon,
  ChevronRight,
  LabelMedium,
  ModalBody,
  ModalFooter,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { useModalCustomOptions, useStake } from "#/shared/hooks"
import {
  ComponentStepProps,
  StepperModalButton,
  useStepperModalContext,
} from "#/ui/Modal"

import { StakedAmountItem, StakingItemContainer } from "../components"

import { ManageType, useManageStakeFlowContext } from "./ManageStakeFlowContext"

export default function ManageStep({
  onClickContinue,
  onClose,
}: ComponentStepProps) {
  const [css, theme] = useStyletron()

  const { stakeId } = useModalCustomOptions<{
    stakeId: string
  }>()

  const selectedStake = useStake(stakeId)

  const { setManageType } = useManageStakeFlowContext()
  const { resetState } = useStepperModalContext()

  const manageActions: {
    label: string
    description: string
    type: ManageType
  }[] = [
    {
      label: "Increase staked amount",
      description: "Add more BTC to your existing stake.",
      type: "increase-amount",
    },
  ]

  useEffect(() => {
    resetState()
  }, [resetState, setManageType])

  if (!selectedStake) return null

  return (
    <>
      <ModalBody
        className={css({
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale300,
        })}
      >
        <StakedAmountItem
          amount={selectedStake.amount}
          lockDuration={selectedStake.lockDuration}
        />

        {manageActions.map(({ label, description, type }) => (
          <StakingItemContainer key={type}>
            <Block>
              <LabelMedium>{label}</LabelMedium>
              <ParagraphSmall color={theme.colors.contentSecondary}>
                {description}
              </ParagraphSmall>
            </Block>
            <ButtonIcon
              shape="square"
              size="small"
              kind="tertiary"
              onClick={(event: SyntheticEvent<HTMLButtonElement>) => {
                event.preventDefault()
                setManageType(type)
                onClickContinue()
              }}
            >
              <ChevronRight size={24} />
            </ButtonIcon>
          </StakingItemContainer>
        ))}
      </ModalBody>
      <ModalFooter>
        <StepperModalButton onClick={onClose}>Close</StepperModalButton>
      </ModalFooter>
    </>
  )
}
